/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.EventRegistrationRpc
 */
import * as References from './EventRegistrationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.EventRegistrationRpc#registerUserToEventSession
 */
export const REGISTER_USER_TO_EVENT_SESSION_MUTATION_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_EventRegistrationRpc_registerUserToEventSession';
export const REGISTER_USER_TO_EVENT_SESSION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: REGISTER_USER_TO_EVENT_SESSION_MUTATION_FIELD_NAME,
  args: ['eventSessionExternalId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.registerUserToEventSessionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.EventRegistrationRpc#deregisterUserFromEventSession
 */
export const DEREGISTER_USER_FROM_EVENT_SESSION_MUTATION_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_EventRegistrationRpc_deregisterUserFromEventSession';
export const DEREGISTER_USER_FROM_EVENT_SESSION_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: DEREGISTER_USER_FROM_EVENT_SESSION_MUTATION_FIELD_NAME,
  args: ['eventSessionExternalId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.deregisterUserFromEventSessionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.EventRegistrationRpc#getUpcomingUserRegisteredEventSessions
 */
export const GET_UPCOMING_USER_REGISTERED_EVENT_SESSIONS_QUERY_FIELD_NAME = 'com_hubspot_academy_learning_events_rpc_EventRegistrationRpc_getUpcomingUserRegisteredEventSessions';
export const GET_UPCOMING_USER_REGISTERED_EVENT_SESSIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_UPCOMING_USER_REGISTERED_EVENT_SESSIONS_QUERY_FIELD_NAME,
  args: ['eventId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getUpcomingUserRegisteredEventSessionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});